import 'client-only'
import {SessionServiceInterface} from '@/src/core/domain/session'
import {Routes} from '@/src/config/routes'
import {inject, injectable} from 'inversify'
import {DI} from '@/src/config/di/types'
import type {IApiClientServiceFactory} from '@/src/ports/services/api'
import type {QueryCacheInterface} from '@/src/ports/services/query-cache'
import type {ClientSession} from '@/src/core/domain/session/client-session'

@injectable()
export class WebClientSessionService implements SessionServiceInterface {
  @inject(DI.IApiClientServiceFactory)
  apiClientFactory!: IApiClientServiceFactory

  @inject(DI.IQueryCacheService)
  queryCache!: QueryCacheInterface

  async load(): Promise<[Nullable<ClientSession>, Record<any, any>]> {
    const cachedSession = this.queryCache.getQueryData<Nullable<ClientSession>>(['session'])
    if (cachedSession !== undefined) {
      return [cachedSession, {}]
    }

    const layoutData = this.queryCache.getQueryData<Nullable<LayoutData>>(['layout'])
    return [layoutData?.session ?? null, {}]
  }

  async refresh(): Promise<Nullable<ClientSession>> {
    const client = this.apiClientFactory('api')
    return await client.get<Nullable<ClientSession>>(Routes.api.auth.refreshSession, {
      credentials: 'include',
    })
  }

  async clear() {
    const client = this.apiClientFactory('api')
    await client.get(Routes.api.auth.logout)
  }

  async getAuthHeaders() {
    return {} as Record<any, any>
  }
}
